import { render, staticRenderFns } from "./AddressItem.vue?vue&type=template&id=29ab808c&"
import script from "./AddressItem.vue?vue&type=script&lang=js&"
export * from "./AddressItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29ab808c')) {
      api.createRecord('29ab808c', component.options)
    } else {
      api.reload('29ab808c', component.options)
    }
    module.hot.accept("./AddressItem.vue?vue&type=template&id=29ab808c&", function () {
      api.rerender('29ab808c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AddressItem.vue"
export default component.exports